module.exports = __webpack_public_path__ + "static_pc/img/7.6e0df4bc.png";